/**************************************************************
* Instagram Section Animation using GSAP ScrollTrigger
**************************************************************/

function fnInstagramSection( oEvent ) {

	if ($('.instagram-images').length && $(window).width() > 1024) {
		// Create timeline for the animation
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: ".instagram-images",
				start: "top top",
				end: "+=250%",
				pin: true,
				scrub: true
			}
		});

		// Add animations to the timeline
		tl.from(".instagram-images .image--3", { scale: 1.5, y: "70%", duration: 1 }, "primaryImage")
			.from(".instagram-images .image--1", {
				scale: 1.1,
				y: "-30%",
				x: "-50%",
				opacity: 1,
				duration: 1
			}, "primaryImage+=0.2")
			.from(".instagram-images .image--2", {
				scale: 1.25,
				x: "-90%",
				y: "-120%",
				opacity: 1,
				duration: 1
			}, "primaryImage+=0.15")
			.from(".instagram-images .image--4", {
				scale: 1.2,
				x: "70%",
				y: "-100%",
				opacity: 1,
				duration: 1
			}, "primaryImage+=0.15")
			.from(".instagram-images .textarea", {
				y: "10%",
				opacity: 0,
				ease: "power1.out",
				duration: 1
			}, "primaryImage+=0.55");
	}

}


// END OF DOCUMENT
